import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      marginInlineEnd: 140,

      [mediaQuery(1200)]: {
        marginInlineEnd: 24,
      },

      [mediaQuery(breakpoints.laptop)]: {
        marginBlockEnd: 28,
      },

      [mediaQuery(breakpoints.tablet)]: {
        marginBlockEnd: 20,
      },
    },

    logo: {
      display: 'block',
      marginBlockEnd: 24,
      width: 'fit-content',

      [mediaQuery(breakpoints.laptop)]: {
        marginBlockEnd: 20,
      },
    },

    text: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      textTransform: 'uppercase',
      marginBlockEnd: 12,
    },

    row: {
      display: 'flex',
      listStyleType: 'none',

      [mediaQuery(breakpoints.laptop)]: {
        flexWrap: 'wrap',
      },
    },

    item: {
      marginInlineEnd: 12,
    },

    imgContainer: {
      display: 'block',
      width: 'fit-content',
    },

    img: {
      borderRadius: 6,
    },
  }),
  {
    name: 'StoreLinks',
  },
);

export default useStyles;
